import { Button } from '@cian/ui-kit';
import { FC } from 'react';

import styles from './ClearTagsAdornment.css';

interface IClearTagsAdornmentProps {
  onAllTagsDeleted: VoidFunction;
  tagsNumber: number;
}

export const ClearTagsAdornment: FC<IClearTagsAdornmentProps> = props => {
  const { tagsNumber, onAllTagsDeleted } = props;

  if (tagsNumber < 2) {
    return null;
  }

  return (
    <div className={styles['clear_tags_button']}>
      <Button size="XS" theme="fill_secondary" onClick={onAllTagsDeleted} data-testid="clear-tags-button">
        Очистить
      </Button>
    </div>
  );
};
